<template>
  <div class="panel cc-panel">
    <p class="panel-heading">
      {{ $t("i18n.chartTitles.ccEnergyPerTemperature") }}
    </p>
    <div class="panel-block">
      <div :id="this.idChartDiv" class="cc-chart"></div>
    </div>
  </div>
</template>
<script>
import * as am5 from '@amcharts/amcharts5'
import * as am5xy from '@amcharts/amcharts5/xy'
import * as am5exporting from '@amcharts/amcharts5/plugins/exporting'
import ccColors from '@/components/ccColors'

export default {
  name: 'ccEnergyPerTemperature',
  props: {
    idChartDiv: {
      type: String,
      required: true
    },
    xAxisDataField: {
      type: String,
      required: true
    },
    data: {
      type: Array,
      required: true
    }
  },
  data () {
    return {}
  },
  mounted () {
    this.buildChart()
  },
  methods: {
    buildChart: function () {
      am5.addLicense(this.$store.state.am5)
      const root = am5.Root.new(this.idChartDiv)

      // Create chart
      const chart = root.container.children.push(am5xy.XYChart.new(root, {
        interactive: false,
        layout: root.verticalLayout,
        connect: false,
        paddingRight: 40,
        paddingTop: 0
      }))

      const xAxis = chart.xAxes.push(
        am5xy.CategoryAxis.new(root, {
          categoryField: this.xAxisDataField,
          renderer: am5xy.AxisRendererX.new(root, {
            minGridDistance: 15
          })
        })
      )

      xAxis.data.setAll(this.data)

      // Create axes
      const yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
        numberFormat: '#',
        renderer: am5xy.AxisRendererY.new(root, {})
      }))

      // Add line series
      this.addSmoothedLineSeries(this.$t('i18n.global.compressor'), 'energyComp', ccColors.energyComp, root, chart, yAxis, xAxis)
      this.addSmoothedLineSeries(this.$t('i18n.global.total'), 'energyTot', ccColors.energyTot, root, chart, yAxis, xAxis)
      this.addSmoothedLineSeries(this.$t('i18n.global.heating'), 'energyHeating', ccColors.heating, root, chart, yAxis, xAxis)
      this.addSmoothedLineSeries(this.$t('i18n.global.cooling'), 'energyCooling', ccColors.cooling, root, chart, yAxis, xAxis)

      // Add legend
      const legend = chart.children.push(am5.Legend.new(root, {
        centerX: am5.p50,
        x: am5.p50,
        clickTarget: 'none' // Disable clickable legends
      }))

      legend.data.setAll(chart.series.values)

      // Add export menu
      am5exporting.Exporting.new(root, {
        menu: am5exporting.ExportingMenu.new(root, {})
      })

      // Add Labels to axises
      chart.children.unshift(am5.Label.new(root, {
        text: 'kWh',
        fontWeight: '500',
        textAlign: 'left',
        y: am5.percent(-10),
        height: 0,
        paddingTop: 30
      }))

      chart.children.unshift(am5.Label.new(root, {
        text: '°C',
        fontWeight: '500',
        textAlign: 'left',
        x: am5.percent(100),
        y: am5.percent(81),
        paddingLeft: 10
      }))

      // Make stuff animate on load
      chart.appear(1000, 100)
    },
    addSmoothedLineSeries: function (title, value, color, root, chart, yAxis, xAxis) {
      // add axis for this line series

      const lineSeries = chart.series.push(
        am5xy.SmoothedXLineSeries.new(root, {
          name: title,
          xAxis: xAxis,
          yAxis: yAxis,
          valueYField: value,
          categoryXField: this.xAxisDataField,
          stroke: color,
          fill: color,
          connect: false
        })
      )

      // Add debugger tooltip
      const tooltip = lineSeries.set('tooltip', am5.Tooltip.new(root, {
        pointerOrientation: 'horizontal'
      }))

      tooltip.label.setAll({
        text: '{name}: {valueY}'
      })

      lineSeries.strokes.template.setAll({
        strokeWidth: 2
      })

      lineSeries.data.setAll(this.data)

      return lineSeries
    }
  }
}
</script>
